import { render, staticRenderFns } from "./NgCard.vue?vue&type=template&id=6dfbf189&scoped=true&"
import script from "./NgCard.vue?vue&type=script&lang=js&"
export * from "./NgCard.vue?vue&type=script&lang=js&"
import style0 from "./NgCard.vue?vue&type=style&index=0&id=6dfbf189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfbf189",
  null
  
)

export default component.exports